import { FunctionComponent } from 'react';
import { D2VDownloadCard } from './ChargeAnytime/D2VDownloadCard';
import { CheckContactDetails } from './CheckContactDetails/CheckContactDetails';
import { HomePlan } from './HomePlan/HomePlan';
import { HomePlanBundle } from './HomePlan/HomePlanBundle';
import { HomeRecoverBanner } from './HomeRecover/HomeRecover';
import { FinalStatementOneInLoss } from './Loss/FinalStatement/FinalStatementOneInLoss';
import { FinalStatementOneReady } from './Loss/FinalStatement/FinalStatementOneReady';
import { FinalStatementOneStaying } from './Loss/FinalStatement/FinalStatementOneStaying';
import { FinalStatementReady } from './Loss/FinalStatement/FinalStatementReady';
import { LossCompleteDualLoss } from './Loss/LossComplete/LossCompleteDualLoss';
import { LossCompleteDualLossDifferentDates } from './Loss/LossComplete/LossCompleteDualLossDifferentDates';
import { LossCompletePending } from './Loss/LossComplete/LossCompletePending';
import { LossCompleteSingleFuel } from './Loss/LossComplete/LossCompleteSingleFuel';
import { LossCompleteSingleLoss } from './Loss/LossComplete/LossCompleteSingleLoss';
import { LossPendingDualFuel } from './Loss/LossPending/LossPendingDualFuel';
import { LossPendingSingleFuel } from './Loss/LossPending/LossPendingSingleFuel';
import { LossPendingSingleLoss } from './Loss/LossPending/LossPendingSingleLoss';

import { DirectDebitSetup } from './Payments/DirectDebitSetup';
import { FixedPlanRenewalCard } from './Renewal/FixedPlanRenewalCard';
import { Renewal } from './Renewal/Renewal';
import { SmartMeterBookingBookingNowAvailable } from './SmartMeterBooking/SmartMeterBookingBookingNowAvailable';
import { SmartMeterBookingRecerts } from './SmartMeterBooking/SmartMeterBookingRecerts';
import { SolarPanelsCard } from './Solar/SolarPanels';
import { DirectDebitReduction } from '@/src/components/ActionCentre/Banners/Payments/DirectDebitReduction';
import {
  EnergyTrackerFirstTimeBanner,
  EnergyTrackerReturningBanner,
} from '@/src/components/ActionCentre/Banners/EnergyTracker/EnergyTrackerBanner';
import { ActionMetaDataKey } from '@/src/types/NextBestAction';
import { MoveOutInProgress } from '@/src/components/ActionCentre/Banners/MoveOut/MoveOutInProgress';
import { MoveOutComplete } from '@/src/components/ActionCentre/Banners/MoveOut/MoveOutComplete';

type MetaData = Partial<Record<ActionMetaDataKey, string>>;

export interface ActionCentreBannerProps {
  'data-testid'?: string;
  utmSource?: string;
  onClick: () => void;
  dismiss: () => void;
  metaData?: MetaData;
}

export type ActionCentreBanner = FunctionComponent<ActionCentreBannerProps>;

export type BannerId = keyof typeof banners;
export const banners = {
  d2VDownloadCard: D2VDownloadCard,
  checkContactDetails: CheckContactDetails,
  moveOutComplete: MoveOutComplete,
  moveOutInProgress: MoveOutInProgress,
  finalStatementReady: FinalStatementReady,
  finalStatementOneReady: FinalStatementOneReady,
  finalStatementOneStaying: FinalStatementOneStaying,
  finalStatementOneInLoss: FinalStatementOneInLoss,
  lossCompleteSingleFuel: LossCompleteSingleFuel,
  lossCompleteSingleLoss: LossCompleteSingleLoss,
  lossCompleteDualLoss: LossCompleteDualLoss,
  lossCompleteDualLossDifferentDates: LossCompleteDualLossDifferentDates,
  lossCompletePending: LossCompletePending,
  lossPendingSingleLoss: LossPendingSingleLoss,
  lossPendingSingleFuel: LossPendingSingleFuel,
  lossPendingDualFuel: LossPendingDualFuel,
  renewal: Renewal,
  smartMeterBookingRecerts: SmartMeterBookingRecerts,
  smartMeterBookingBookingNowAvailable: SmartMeterBookingBookingNowAvailable,
  homeplan: HomePlan,
  homeplanBundle: HomePlanBundle,
  greenlightNew: EnergyTrackerFirstTimeBanner,
  greenlightViewAgain: EnergyTrackerReturningBanner,
  directDebitSetup: DirectDebitSetup,
  solarPanels: SolarPanelsCard,
  directDebitReduction: DirectDebitReduction,
  renewalWindow: FixedPlanRenewalCard,
  homeRecover: HomeRecoverBanner,
};
